import React, { useState,useEffect } from 'react';
import style from './Navbar.module.css';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menu, setMenu] = useState(1);

  const onClickMenu = (menuValue) => {
    setMenu(menuValue);
    if (menuValue === 1) {
      navigate('/');
    } else {
      navigate('/newsandarticles');
    }
  }
  useEffect(() => {
    if (location.pathname === '/') {
      setMenu(1);
    }
    else if (location.pathname === '/termsConditions' || location.pathname === '/privacyPolicy') {
      setMenu(3);
    }
    else{
      setMenu(2);
    }
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <nav className="w-full flex justify-center items-center py-10">
      <section>
        <img src="/images/Horo_Logo.svg" alt="logo" className=' md:px-0 ph:px-10' />
        <p className='my-5'></p>
        <aside className='flex gap-10 justify-center text-line lg:text-[20px] md:text-[18px] ph:text-[16px]'>
          <div>
            <button onClick={() => onClickMenu(1)}  className={`${menu === 1 ? style.activeBT : ''}`}>หน้าหลัก</button>
            <p className={`${menu === 1 ? 'w-[50%] mx-auto rounded-lg h-[6px] bg-line' : ''}`}></p>
          </div>
          <div>
            <button onClick={() => onClickMenu(2)}  className={`${menu === 2 ? style.activeBT : ''}`}>ข่าวสารและบทความ</button>
            <p className={`${menu === 2 ? 'w-[50%] mx-auto rounded-lg h-[6px] bg-line' : ''}`}></p>
          </div>
        </aside>
      </section>
    </nav>
  );
};

export default Navbar;
